import React, { useEffect, useState, useRef } from 'react';
// import axios from 'axios'; npm install axios
// import MapLeaflet from './map_leaflet';
import MapLeaflet from './map_leaflet';
import buspath from './output_path';
import bus_stop_loc from './bus_stops_data';
import DraggableButton from './drag_button';
import { baseURL } from '../constants';
import VisitBox from './VisitBox';

const haversine = require('haversine-distance');
const GPSData = (props) => {
  const [latitude, setLatitude] = useState(28.545396761347078);
  const [locationResponseData, setlocationResponseData] = useState([{
    "device": 12,
    "device_name": "OFFLINE",
    "marker_pic_url": null,
    "latitude": "28.545396761347078",
    "longitude": "77.18716496818183",
    "timestamp": "2024-12-22T14:36:04.219967Z",
    "raw_latitude": "28.546680",
    "raw_longitude": "77.185270",
    "stop_name": "OFFLINE",
    "distance_to_next_stop": "125.239182",
    "usd": "90.628669",
    "csd": "7.103922"
  }
  ]);
  const [choice, setChoice] = useState(locationResponseData[0].device);
  const [busdata, setbusdata] = useState(locationResponseData.find(bus => bus.device === parseInt(choice)));
  const [longitude, setLongitude] = useState(77.18716496818183);
  const [busav, setbusav] = useState('Inoperative')
  const [eta, seteta] = useState(null)
  // const ADAFRUIT_IO_USERNAME = process.env.REACT_APP_ADAFRUIT_IO_USERNAME;
  // const ADAFRUIT_IO_KEY = process.env.REACT_APP_ADAFRUIT_IO_KEY;
  // const ApiKey = process.env.REACT_APP_API_KEY;
  const [closestbusstop, setclosestbusstop] = useState([null, Infinity]);
  const [udistance, setUdistance] = useState(Infinity);
  const [nextstop, setNextstop] = useState(null);
  const [nsd, setnsd] = useState(null);
  // const locationUrl = `http://192.168.1.7:8000/bustracker/device-locations/`;
  const locationUrl = `${baseURL}/bustracker/device-locations/`;
  const bus_stop_length = bus_stop_loc.length;
  const intervalRef = useRef(null); // To store the interval ID and prevent overlapping intervals

  const busTimings = [
    { start: "08:25", end: "10:30" },
    { start: "12:00", end: "13:30" },
    { start: "16:50", end: "18:00" },
  ];

  const currentTime = new Date();
  const currentHours = currentTime.getHours();
  const currentMinutes = currentTime.getMinutes();
  const currentTimeString = `${currentHours.toString().padStart(2, "0")}:${currentMinutes.toString().padStart(2, "0")}`;

  // Function to check if current time is within any bus timing range
  const isBusOperational = (current, timings) => {
    return timings.some((timing) => current >= timing.start && current <= timing.end);
  };

  const hasFetched = useRef(false); // Persist across renders
  const [uniqueVisits, setUniqueVisits] = useState(0);
  const getUniqueVisits = async () => {
    if (hasFetched.current) return; // Prevent duplicate calls
    hasFetched.current = true; // Mark as fetched

    try {
      const response = await fetch(`${baseURL}/bustracker/unique-visit-api/`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Connection: 'keep-alive',
        },
      });

      const uniqueVisits = await response.json();
      setUniqueVisits(uniqueVisits.unique_visit_count);
    } catch (error) {
      console.error("Error fetching unique visits:", error);
    }
  };

  useEffect(() => {
    getUniqueVisits();
  }, []);

  const setlivebus = async () => {
    try {
      const locationResponseData = await fetch(locationUrl, {
        method: 'GET',
      }).then(response => response.json());
      if (locationResponseData.length === 0) {
        console.log('No data received');
      }
      else {
        const filteredData = locationResponseData.filter(bus => !(bus.device_name.includes('test')));
        setlocationResponseData(filteredData);
      }

      let flag = 0;

      for (let i = 0; i < locationResponseData.length; i++) {
        let modtime = new Date(locationResponseData[i].timestamp);
        let curr = new Date();
        let busav = 'Inoperative';
        if (modtime.toDateString() === curr.toDateString()) {
          if (modtime.getHours() === curr.getHours()) {
            if ((parseInt(curr.getMinutes()) - parseInt(modtime.getMinutes())) < 3) {
              busav = 'Running'
            }
            else {
              busav = 'Inoperative'
            }
          }
        }
        if (busav === 'Running') {
          try {
            setChoice(locationResponseData[i].device);
            setbusdata(locationResponseData[i]);
            flag = 1;
            break;
          } catch (error) {
            console.log(error)
          }
        }
      }
      if (flag === 0) {
        try {
          setChoice(locationResponseData[0].device);
          setbusdata(locationResponseData[0]);
        } catch (error) {
          console.log(error) 
        }
      }

    } catch (error) {
      console.log(error)
      setTimeout(() => {
        // alert('Unable to connect to the server. Please try again later.') 
        console.log('Unable to connect to the server. Please try again later.')
      }, 1000);
    }
  }

  useEffect(() => {
    setlivebus();
  }, []);

  let controller;

  const fetchGPSData = async () => {
    try {
      // const latitudeUrl = `https://io.adafruit.com/api/v2/arnav_abhishek_/feeds/latitude/data`
      // const locationUrl = `https://io.adafruit.com/api/v2/${ADAFRUIT_IO_USERNAME}/feeds/latitude/data`;
      // const locationUrl = `http://192.168.1.7:8000/bustracker/device-locations/`;
      // const headers = {
      //   'X-AIO-Key': ADAFRUIT_IO_KEY
      // };

      // const [locationResponse] = await Promise.all([
      //   axios.get(locationUrl, { headers, params: { limit: 1 } }),
      // ]);

      if (controller) {
        controller.abort();
      }
      controller = new AbortController();
      const signal = controller.signal;

      const locationResponseData = await fetch(locationUrl, {
        method: 'GET',
        signal: signal,
        mode: 'cors',
        headers: {
          Connection: 'keep-alive', // Keep the connection alive for subsequent requests
          // Connection: 'close', // Explicitly close the connection after the request
        },
      }).then(response => response.json());

      // console.log(locationResponseData)
      if (locationResponseData.length === 0) {
        console.log('No data received');
      }
      else {
        const filteredData = locationResponseData.filter(bus => !(bus.device_name.includes('test')));
        setlocationResponseData(filteredData);
      }

      for (let i = 0; i < locationResponseData.length; i++) {
        let modtime = new Date(locationResponseData[i].timestamp);
        let curr = new Date();
        let busav = 'Inoperative';
        if (modtime.toDateString() === curr.toDateString()) {
          if (modtime.getHours() === curr.getHours()) {
            if ((parseInt(curr.getMinutes()) - parseInt(modtime.getMinutes())) < 3) {
              busav = 'Running'
            }
            else {
              busav = 'Inoperative'
            }
          }
        }
        if (busav === 'Running') {
          try {
            setChoice(locationResponseData[i].device);
            setbusdata(locationResponseData[i]);       
            break;
          } catch (error) {
            console.log(error)
          }
        }
      }
      // let latitudedata= await fetch(latitudeUrl)
      // let latdata= await latitudedata.json()
      // let longitudedata= await fetch(longitudeUrl)
      // let londata= await longitudedata.json()

      let point = { "latitude": parseFloat(locationResponseData.latitude), "longitude": parseFloat(locationResponseData.longitude) }
      // let point = { "latitude": parseFloat(locationResponseData.lat), "longitude": parseFloat(locationResponseData.lon) }

      // console.log(locationResponseData)
      // let speed = parseFloat(locationResponseData.ele)
      let speed = 30;

      let modtime = new Date(busdata.timestamp);

      let curr = new Date();
      let busav = 'Inoperative';
      if (modtime.toDateString() === curr.toDateString()) {
        if (modtime.getHours() === curr.getHours()) {
          if ((parseInt(curr.getMinutes()) - parseInt(modtime.getMinutes())) < 3) {
            busav = 'Running'
          }
          else {
            busav = 'Inoperative'
          }
        }
      }

      // // Road Matching
      // // OSRM public server
      // const base_url = "https://router.project-osrm.org/nearest/v1/driving";

      // let cord = `${point.longitude},${point.latitude}`;

      // let closestPoint = { "latitude": point.latitude, "longitude": point.longitude }
      // // API endpoint
      // const url = `${base_url}/${cord}?number=1`;

      // try {
      //   const response = await fetch(url);
      //   if (!response.ok) {
      //     throw new Error(`HTTP error! status: ${response.status}`);
      //   }
      //   const data = await response.json();
      //   const loc = data.waypoints[0].location;
      //   closestPoint = { "latitude": loc[1], "longitude": loc[0] };
      // } catch (err) {
      //   let minDistance = Infinity;
      //   buspath.forEach((coord, index) => {
      //     const distance = haversine(point, coord);
      //     if (distance < minDistance) {
      //       minDistance = distance;
      //       closestIndex = index;
      //     }
      //   })
      //   closestPoint = buspath[closestIndex];
      // }

      let closestPoint = point;
      let minDistance2 = Infinity;
      let nudistance;
      let cstop = { 'name': '' };

      // let cbs = null;
      // let minDistance2 = Infinity;
      // bus_stop_loc.forEach((stop, index) => {
      //   let coord = { "latitude": parseFloat(stop.latitude), "longitude": parseFloat(stop.longitude) }
      //   const distance = haversine(closestPoint, coord);
      //   if (distance < minDistance2) {
      //     minDistance2 = distance;
      //     cbs = index;
      //   }
      // })
      // let cstop = bus_stop_loc[cbs];
      // let nudistance;
      // if (cbs < bus_stop_length - 1) {
      //   let ustop = bus_stop_loc[cbs + 1];
      //   let ucoord = { "latitude": parseFloat(ustop.latitude), "longitude": parseFloat(ustop.longitude) };
      //   nudistance = haversine(closestPoint, ucoord);
      //   if (minDistance2 > closestbusstop[1]) {
      //     if (nudistance < udistance) {
      //       setNextstop(ustop.name);
      //       let nsd = nudistance
      //       setnsd(nsd)
      //     }
      //     else {
      //       let dstop = bus_stop_loc[cbs - 1];
      //       let dcoord = { "latitude": parseFloat(dstop.latitude), "longitude": parseFloat(dstop.longitude) };
      //       let ddistance = haversine(closestPoint, dcoord);
      //       setNextstop(dstop.name);
      //       let nsd = ddistance
      //       setnsd(nsd)
      //     }
      //   }
      //   else if (minDistance2 < closestbusstop[1]) {
      //     setNextstop(cstop.name);
      //     let nsd = minDistance2
      //     setnsd(nsd)
      //   }
      // }
      // else {
      //   if (minDistance2 < closestbusstop[1]) {
      //     setNextstop(cstop.name);
      //     let nsd = minDistance2
      //     setnsd(nsd)
      //   }
      //   else {
      //     let dstop = bus_stop_loc[cbs - 1];
      //     let dcoord = { "latitude": parseFloat(dstop.latitude), "longitude": parseFloat(dstop.longitude) };
      //     let ddistance = haversine(closestPoint, dcoord);
      //     setNextstop(dstop.name);
      //     let nsd = ddistance
      //     setnsd(nsd)
      //   }
      // }


      if (speed === 0 || speed === null) {
        speed = 30
      }
      let t = nsd / (speed * 100 / 6);

      let tim;
      if (t < 1) {
        tim = (t * 60).toFixed(0) + ' sec'
      }
      else {
        tim = (t).toFixed(1) + ' mins'
      }

      setbusav(busav)
      setUdistance(nudistance)
      seteta(tim)
      setclosestbusstop([cstop.name, minDistance2]);
      setLatitude(closestPoint.latitude);
      setLongitude(closestPoint.longitude);
      setNextstop(busdata.stop_name);
      setnsd(busdata.distance_to_next_stop);
    } catch (error) {
      // console.log(error)
      // console.error('Error fetching data:', error);
      console.log('Unable to connect to the server. Please try again later.')
    }
  };


  useEffect(() => {
    // fetchGPSData(); // Initial fetch

    let selectedBus = locationResponseData.find(bus => bus.device === parseInt(choice));
    if (!selectedBus) {
      selectedBus = busdata;
    }
    setbusdata(selectedBus);

    // Clear any existing interval before setting a new one
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(fetchGPSData, 1000);

    return () => clearInterval(intervalRef.current); // Cleanup on unmount or dependency change
  }, [choice, locationResponseData]); // Depend only on necessary changes

  if (parseInt(latitude) !== 0 && parseInt(longitude) !== 0) {
    // data lagging alternate method
    return (
      <div >
        <DraggableButton onOptionClick={(e) => {
          const selectedValue = e; // Get the selected value
          // Parse selected value and find matching bus
          const selectedBus = locationResponseData.find(bus => bus.device === selectedValue);
          // Update states
          setChoice(selectedValue);
          setbusdata(selectedBus); // Update bus data

        }
        } locationresponsedata={locationResponseData} />
        {
          <div className='row' style={{ width: '96%', margin: '2.2%', justifySelf: 'center' }}>
            <div className='col-md'>
              <h4>Bus : <mark style={{ color: props.darkmode ? 'white' : 'black', background: props.darkmode ? 'transparent' : '#FEF7C7', fontWeight: 'bold' }}>{busdata.device_name.replace('Bus', '').replace('bus', '')}</mark></h4>
            </div>
            {busav === 'Running' && (
              <div className='col-md'>
                {nextstop === 'PARKED' ? (
                  <h4>
                    <mark
                      style={{
                        color: props.darkmode ? 'white' : 'black',
                        background: props.darkmode ? 'transparent' : '#FEF7C7',
                        fontWeight: 'bold'
                      }}
                    >
                      Bus is currently parked
                    </mark>
                  </h4>
                ) : (
                  <h4>Next Stop:
                    <mark
                      style={{
                        color: props.darkmode ? 'white' : 'black',
                        background: props.darkmode ? 'transparent' : '#FEF7C7',
                        fontWeight: 'bold'
                      }}
                    >
                      {nextstop}
                    </mark>
                  </h4>
                )}
              </div>
            )}
            {busav === 'Inoperative' && (
              <div
                className="col-md"
                style={{
                  width: "100%", // Full width for mobile
                  textAlign: "center", // Center the text
                }}
              >
                {!isBusOperational(currentTimeString, busTimings) ? (
                  <h4
                    style={{
                      fontSize: window.innerWidth < 768 ? 17 : 20, // Smaller font for mobile
                      marginLeft: window.innerWidth < 768 ? 0 : 35, // Adjust margin for mobile
                      marginTop: 10,
                      whiteSpace: "nowrap", // Keeps text in one line
                    }}
                  >
                    <a href='./#/Bus_Schedule'>
                    <mark
                      style={{
                        fontWeight: "bold",
                        color: props.darkmode ? "white" : "black",
                        background: props.darkmode ? "transparent" : "#FEF7C7",
                      }}
                    >
                      Service resumes during operational hours ↗
                    </mark>
                    </a>
                  </h4>
                ) : (
                  <h4
                    style={{
                      fontSize: window.innerWidth < 768 ? 17 : 20,
                      marginLeft: window.innerWidth < 768 ? 0 : 35,
                      marginTop: 10,
                      whiteSpace: "nowrap",
                    }}
                  >
                    <mark
                      style={{
                        fontWeight: "bold",
                        color: props.darkmode ? "white" : "black",
                        background: props.darkmode ? "transparent" : "#FEF7C7",
                      }}
                    >
                      Device Offline, Service resumes shortly
                    </mark>
                  </h4>
                )}
              </div>
            )}
            {busav === 'Running' && nextstop !== "PARKED" && <div className='col-md'>
              <h4>Estimated Arrival Time:<mark style={{ color: props.darkmode ? 'white' : 'black', background: props.darkmode ? 'transparent' : '#FEF7C7', fontWeight: 'bold' }}>{eta}</mark></h4>
            </div>}
            {/* <div className='col-sm'>
          <h4>Distance to Next Stop: <mark>{nextstopdistance.toFixed(0)} m</mark></h4>
          </div>
          <div className='col-sm'>
          <h4>Speed: <mark>{speed} km/hr</mark></h4>   
          </div> */}
          </div>
        }
        {/* {
          <div className="row" style={{ width: '96%', margin: '2.2%', justifySelf: 'center' }}>
            <div className="col-md">
              <label htmlFor="busSelect" style={{ marginRight: '5px' }}>Select Bus : </label>
              <select
                id="busSelect"
                value={choice}
                onChange={(e) => {
                  const selectedValue = e.target.value; // Get the selected value

                  // Parse selected value and find matching bus
                  const selectedBus = locationResponseData.find(bus => bus.device === parseInt(selectedValue));

                  // Update states
                  setChoice(selectedValue);
                  setbusdata(selectedBus); // Update bus data

                }}
              >
                // Generate options dynamically 
                {locationResponseData.map((bus) => (
                  <option key={bus.device} value={bus.device}>
                    {bus.device_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        } */}
        <MapLeaflet coord={locationResponseData} busdata={busdata} setdarkmode={props.setDarkmode} darkmode={props.darkmode} />
        <VisitBox totalVisits={uniqueVisits} />
      </div >
    );
  }
  // [ latitude, longitude ]
  // variables storing lat and long
};

export default GPSData;